// extracted by mini-css-extract-plugin
module.exports = {"tabs":"_1SmtI","loading":"_2V2lj"};